import { Controller } from "react-hook-form";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const RHFSelectFieldMultiple = ({
  name,
  label,
  options,
  optionIdentifiers,
  control,
  validationHelper,
  rules,
  viewMode,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        const { value } = field;
        return (
          <FormControl
            fullWidth
            error={error ? true : false}
            disabled={viewMode}
          >
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
              {...field}
              labelId={`${name}-label`}
              label={label}
              // getOptionLabel={(option) => option[optionIdentifiers.label]}
              error={error !== undefined}
              multiple
              input={<OutlinedInput label={label} />}
              renderValue={(selected) => {
                return selected
                  .map((selectedId) => {
                    const option = options.find(
                      (opt) => opt[optionIdentifiers.id] === selectedId,
                    );
                    return option
                      ? option[optionIdentifiers.label]
                      : selectedId;
                  })
                  .join(", ");
              }}
              MenuProps={MenuProps}
            >
              {options.map((option) => {
                return (
                  <MenuItem
                    key={option[optionIdentifiers.id]}
                    value={option[optionIdentifiers.id]}
                  >
                    <Checkbox
                      checked={value.indexOf(option[optionIdentifiers.id]) > -1}
                    />
                    <ListItemText primary={option[optionIdentifiers.label]} />
                  </MenuItem>
                );
              })}
            </Select>
            {error ? (
              <FormHelperText>
                {validationHelper[name][error.type]}
              </FormHelperText>
            ) : null}
          </FormControl>
        );
      }}
    />
  );
};
